export function FormatMoney({ value }) {
    // const moduleValue = Math.abs(value)

    // return(
    //     <>
    //     {
    //         moduleValue >= 1000 && moduleValue < 1000000  ? 
    //             <p>
    //                 {
    //                     new Intl.NumberFormat('pt-BR', 
    //                     { style: 'currency', currency: 'BRL', maximumSignificantDigits: 3 }
    //                     ).format(value / 1000)
    //                 }
    //                 K
    //             </p>
    //         :
    //         moduleValue >= 1000000 && moduleValue < 1000000000  ? 
    //             <p>
    //                 {
    //                     new Intl.NumberFormat('pt-BR', 
    //                     { style: 'currency', currency: 'BRL', maximumSignificantDigits: 3 }
    //                     ).format(value / 1000000)
    //                 }
    //                 M
    //             </p>
    //         :
    //         moduleValue >= 1000000000 ? 
    //             <p>
    //                 {
    //                     new Intl.NumberFormat('pt-BR', 
    //                     { style: 'currency', currency: 'BRL', maximumSignificantDigits: 3}
    //                     ).format(value / 1000000000)
    //                 }
    //                 B
    //             </p>
    //         :
    //             <p>
    //                 {
    //                     new Intl.NumberFormat('pt-BR', 
    //                     { style: 'currency', currency: 'BRL', minimumFractionDigits: 2 }
    //                     ).format(value)
    //                 }
    //             </p>
    //     }
    //     </>
    // )

    //const moduleValue = value

    return (
        <>
            {
                <p>
                    {
                        new Intl.NumberFormat('pt-BR',
                            { style: 'currency', currency: 'BRL'}
                        ).format(value)
                        
                    }
                </p>
            }
        </>
    )
}
